import {Component, OnInit, Inject}                                     from '@angular/core';
import {Validators, UntypedFormGroup, UntypedFormControl, FormControl} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA}                                 from '@angular/material/dialog';
import {ApiService}                                                    from '@src/app/shared/services/api.service';
import moment                                                          from 'moment';
import {ToastrService}                                                 from 'ngx-toastr';

@Component({
    standalone: false,
    selector: 'app-edit-price-tier-modal',
    templateUrl: './edit-price-tier-modal.component.html',
})
export class EditPriceTierModalComponent implements OnInit
{
    public priceTierForm: UntypedFormGroup;
    public currentDate: Date = new Date();

    public constructor(
        private apiService: ApiService,
        private dialogRef: MatDialogRef<EditPriceTierModalComponent>,
        private toast: ToastrService,
        @Inject(MAT_DIALOG_DATA) public data: { priceTier: any, type: string, effectiveFrom?: Date }
    )
    {
    }

    public ngOnInit(): void
    {
        if (this.data?.effectiveFrom) {
            this.currentDate = this.data.effectiveFrom;
        }
        this.initForm();
    }

    private initForm(): void
    {
        this.priceTierForm = new UntypedFormGroup({
            id: new UntypedFormControl(
                this.data?.priceTier ? this.data?.priceTier?.id : ''
            ),
            product_id: new UntypedFormControl(
                this.data?.priceTier ? this.data?.priceTier?.product_id : ''
            ),
            manufacturer_id: new UntypedFormControl(
                this.data?.priceTier ? this.data?.priceTier?.manufacturer_id : '',
                Validators.required
            ),
            effective_from: new FormControl<Date>(null, Validators.required),
            tier: new UntypedFormControl(
                {value: this.data?.priceTier ? this.data?.priceTier?.tier : 0, disabled: this.data?.type === 'edit'},
                Validators.required
            ),
            operative_cost: new FormControl<number>(
                this.data?.priceTier ? this.data?.priceTier?.operative_cost : '',
                Validators.required
            ),
            subcontractor_cost: new FormControl<number>(
                this.data?.priceTier ? this.data?.priceTier?.subcontractor_cost : '',
                Validators.required
            ),
            material_cost: new FormControl<number>(
                this.data?.priceTier ? this.data?.priceTier?.material_cost : '',
                Validators.required
            ),
            sell_price: new FormControl<number>(
                this.data?.priceTier ? this.data?.priceTier?.sell_price : '',
                Validators.required
            )
        });
    }

    public save(): void
    {
        this.priceTierForm.markAllAsTouched();

        if (this.priceTierForm.valid) {
            const payload = {
                ...this.priceTierForm.getRawValue(),
                effective_from: moment(this.priceTierForm.get('effective_from').value).format('YYYY-MM-DD HH:mm:ss'),
            };

            if (this.data?.type === 'edit') {
                // Update
                this.apiService.update('products/prices', this.priceTierForm.get('id').value, payload).subscribe({
                    next: (response) => {
                        this.dialogRef.close(response);
                        this.toast.success('Price successfully updated.');
                    },
                    error: (error) => {
                        console.error('Error updating price tier:', error);
                    }
                });
            } else {
                // Create
                this.apiService.create('products/prices', payload).subscribe({
                    next: (response) => {
                        this.dialogRef.close(response);
                        this.toast.success('New price successfully saved.');
                    },
                    error: (error) => {
                        if (error.status === 422 && error.error?.message === 'Tier is not unique') {
                            this.toast.error('That tier number is already in use. Please enter a different tier.');
                            this.priceTierForm.get('tier').reset();
                            this.priceTierForm.get('tier').markAsTouched();
                        } else {
                            this.toast.error('An error occurred. Please try again.');
                        }
                    }
                });
            }
        } else {
            this.toast.error('Please fill in all required fields.');
        }
    }
}
